export default "__VITE_ASSET__BDYtGFFE__"